import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const CancelConfirmModel = ({ showDeleteConfirmationModal, setShowDeleteConfirmationModal, message, confirmDelete, cancelDelete }) => {
    return (
        <Modal show={showDeleteConfirmationModal} onHide={() => setShowDeleteConfirmationModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body><div className="alert alert-danger">{message}</div></Modal.Body>
            <Modal.Footer>
                <Button variant="default" onClick={confirmDelete}>
                    Yes
                </Button>
                <Button variant="danger" onClick={cancelDelete}>
                    No
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CancelConfirmModel